import React, { useState,useEffect } from "react";
import "./ACService.css";
import SplitACRepair from "../images/Split AC Repair.webp";
import WindowACService from "../images/WindowACService.webp";
import ACInstallation from "../images/AC Installation.webp";
import  ACGasFilling from "../images/AC Gas Filling.webp";
import  ACMaintenance from "../images/AC Maintenance.webp";
import  DoorstepACService from "../images/Doorstep AC Service.webp";
import ACRepairSupport from "../images/AC Repair.webp";
import customer1 from "../images/cutomer1.webp";


function ACService() {
  
      useEffect(() => {
  
      document.title =
        "AC Service - Embarque Services";
  
    }, []);
    const [formData, setFormData] = useState({
      name: "",
      phone: "",
      location: "",
      issue: "",
    });
  
    const [loading, setLoading] = useState(false);
  
    const handleChange = (e) => {
  
      setFormData({
        ...formData,
        [e.target.name]: e.target.value,
      });
  
    };
  
    const handleSubmit = async (e) => {
  
      e.preventDefault();
  
      setLoading(true);
  
      const sendData = {
        ...formData,
        toMail: "expresshelplinecare@gmail.com",
      };
  
      try {
  
        const res = await fetch(
          "https://form.e2ecrm.in/api/sendmail",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(sendData),
          }
        );
  
        await res.json();
  
        alert(
          "Thank you! Your service request is confirmed. Our engineer will call you shortly."
        );
  
        setFormData({
          name: "",
          phone: "",
          location: "",
          issue: "",
        });
  
      } catch (err) {
  
        console.log(err);
  
        alert("Error sending form");
  
      } finally {
  
        setLoading(false);
  
      }
    };
  
  return (
    <>

    
      {/* SPINNER */}

      {loading && (

        <div className="spinner-overlay">

          <div className="spinner"></div>

        </div>

      )}

      {/* AC HERO SECTION */}

      <div className="ac-home">

        <section className="ac-hero">

          {/* LEFT APPLIANCE */}

          <div className="ac-appliance-section">

            {/* <img
              className="ac-machine-img"
              src="https://cdn-icons-png.flaticon.com/512/2933/2933245.png"
              alt="AC Service"
            /> */}

          </div>

          {/* CONTENT */}

          <div className="ac-content">

            <h1>
              AC <br />
              Repair & <br />
              Maintenance <br />
              Service At <br />
              Your Doorsteps
            </h1>

          </div>

          {/* FORM */}

          <div className="ac-booking-form">

            <h2>
              +91 93639 29984
            </h2>

            <p>
              CALL US TODAY
            </p>

            <span>
              Register your AC service complaints
            </span>

            <form onSubmit={handleSubmit}>

              <input
                type="text"
                name="name"
                placeholder="Name"
                value={formData.name}
                onChange={handleChange}
                required
              />

              <input
                type="text"
                name="phone"
                placeholder="Phone Number"
                value={formData.phone}
                onChange={handleChange}
                required
              />

              <input
                type="text"
                name="location"
                placeholder="Location"
                value={formData.location}
                onChange={handleChange}
                required
              />

              <textarea
                name="issue"
                placeholder="Describe the AC issue..."
                value={formData.issue}
                onChange={handleChange}
              ></textarea>
          <p>Your personal information is handled responsibly and used only for the services you request.</p>


              <button type="submit">

                {loading ? "Sending..." : "SUBMIT"}

              </button>

            </form>

          </div>

        </section>

      </div>
          
{/* AC About Section */}

<section className="ac-about-section">

  {/* Left Content */}

  <div className="ac-about-left">

    <h1>
      Trusted AC <br />
      Repair & <br />
      Maintenance <br />
      Experts for <br />
      Your Comfort
    </h1>

    <div className="ac-about-box">

      <p>
        With 8+ years of experience in AC repair and maintenance,
        our technicians provide fast and reliable doorstep solutions.
      </p>

      <p>
        From split AC to window AC systems, we handle cooling,
        gas filling, installation, and compressor issues professionally.
      </p>

    </div>

  </div>

  {/* Right Counter */}

  <div className="ac-about-right">

    <h4>
      OUR SERVICE ACHIEVEMENTS
    </h4>

    <div className="ac-counter-grid">

      <div className="ac-counter-box">
        <h1>8+</h1>
        <p>Years Experience</p>
      </div>

      <div className="ac-counter-box">
        <h1>50000+</h1>
        <p>AC Services Completed</p>
      </div>

      <div className="ac-counter-box">
        <h1>60+</h1>
        <p> Experienced Technicians </p>
      </div>

      <div className="ac-counter-box">
        <h1>25+</h1>
        <p>Service Areas Covered</p>
      </div>

    </div>

  </div>

</section>

{/* AC Services Section */}

<section className="ac-services-section">

  <h1 className="ac-service-title">
    Our AC Services
  </h1>

  <div className="ac-services-grid">

    {/* Card 1 */}

    <div className="ac-service-card">

      <img
        src={SplitACRepair}  alt="split ac"
      />

      <h2>
        Split AC Repair
      </h2>

      <p>
        Professional split AC repair services for cooling,
        water leakage, and performance issues.
      </p>

    </div>

    {/* Card 2 */}

    <div className="ac-service-card">

      <img
        src={WindowACService}        alt="window ac"
      />

      <h2>
        Window AC Service
      </h2>

      <p>
        Complete maintenance and repair support for all
        window AC models and brands.
      </p>

    </div>

    {/* Card 3 */}

    <div className="ac-service-card">

      <img
        src={ACInstallation} alt="installation"
      />

      <h2>
        AC Installation
      </h2>

      <p>
        Safe and professional AC installation and setup
        support at your home or office.
      </p>

    </div>

    {/* Card 4 */}

    <div className="ac-service-card">

      <img
        src={ACGasFilling}  alt="gas filling"
      />

      <h2>
        AC Gas Filling
      </h2>

      <p>
        Fast gas charging services for improved cooling
        and better AC performance.
      </p>

    </div>

    {/* Card 5 */}

    <div className="ac-service-card">

      <img
        src={ ACMaintenance}   alt="maintenance"
      />
      

      <h2>
        AC Maintenance
      </h2>

      <p>
        Regular AC cleaning and maintenance support
        to increase cooling efficiency.
      </p>

    </div>

    {/* Card 6 */}

    <div className="ac-service-card">

      <img
        src={ DoorstepACService}
        alt="doorstep service"
      />

      <h2>
        Doorstep AC Service
      </h2>

      <p>
        Quick doorstep AC repair support from experienced
        technicians at affordable pricing.
      </p>

    </div>

  </div>

</section>

{/* AC WHY CHOOSE US */}

<section className="ac-choose-section">

  <div className="ac-choose-overlay">

    <h4>
      WHY CHOOSE OUR AC SERVICE
    </h4>

    <h1>
      Trusted AC Repair <br />
      & Maintenance Solutions
    </h1>

    <div className="ac-choose-grid">

      {/* BOX 1 */}

      <div className="ac-choose-box">

        <div className="ac-choose-icon">
          ❄️
        </div>

        <h2>
          Expert AC Repair
        </h2>

      </div>

      {/* BOX 2 */}

      <div className="ac-choose-box">

        <div className="ac-choose-icon">
          ⏰
        </div>

        <h2>
          Same Day Service
        </h2>

      </div>

      {/* BOX 3 */}

      <div className="ac-choose-box">

        <div className="ac-choose-icon">
          💰
        </div>

        <h2>
          Affordable Pricing
        </h2>

      </div>

      {/* BOX 4 */}

      <div className="ac-choose-box">

        <div className="ac-choose-icon">
          🚚
        </div>

        <h2>
          Doorstep Support
        </h2>

      </div>

      {/* BOX 5 */}

      <div className="ac-choose-box">

        <div className="ac-choose-icon">
          🧰
        </div>

        <h2>
          Quality Replacement Parts
        </h2>

      </div>

      {/* BOX 6 */}

      <div className="ac-choose-box">

        <div className="ac-choose-icon">
          👨‍🔧
        </div>

        <h2>
          Experienced Technicians
        </h2>

      </div>

    </div>

  </div>

</section>

{/* AC REQUEST INFO */}

<section className="ac-request-section">

  {/* Left Content */}

  <div className="ac-request-left">

    <h1>
      AC Repair <br />
      Support
    </h1>

    <h2>
      Fast & Reliable AC <br />
      Service at <br />
      Your Doorstep
    </h2>

    <p>
      We provide complete AC repair and maintenance solutions
      for homes and offices. Our experienced technicians handle
      split AC, window AC, gas filling, cooling issues,
      water leakage, installation, and servicing with
      professional doorstep support at affordable pricing.
    </p>

  </div>

  {/* Right Image */}

  <div className="ac-request-right">

    <img
      src={ACRepairSupport} alt="ac service"
    />

  </div>

</section>


{/* AC CUSTOMER SUPPORT */}

{/* <section className="ac-support-section">

  

  <div className="ac-support-image">

    <img
      src={customer1} alt="ac customer support"
    />

  </div>



  <div className="ac-support-content">

    <h1>
      AC Customer Support
    </h1>

   

    <div className="ac-support-box">
      <span>+</span>
      <p>Quick Booking Through Call & WhatsApp</p>
    </div>

    <div className="ac-support-box">
      <span>+</span>
      <p>Same Day AC Technician Visit</p>
    </div>

    <div className="ac-support-box">
      <span>+</span>
      <p>Professional Split & Window AC Support</p>
    </div>

    <div className="ac-support-box">
      <span>+</span>
      <p>Experienced AC Repair Technicians</p>
    </div>

    <div className="ac-support-box">
      <span>+</span>
      <p>Affordable AC Service Charges</p>
    </div>

  </div>

</section> */}


<section class="working-hours-section">
  <div class="container">
    <div class="working-hours-box">
      <h2>Working Hours</h2>

      <div class="working-time">
        <span>Monday</span>
        <strong>07:00 AM – 09:00 PM</strong>
      </div>

      <div class="working-time">
        <span>Tuesday</span>
        <strong>07:00 AM – 09:00 PM</strong>
      </div>

      <div class="working-time">
        <span>Wednesday</span>
        <strong>07:00 AM – 09:00 PM</strong>
      </div>

      <div class="working-time">
        <span>Thursday</span>
        <strong>07:00 AM – 09:00 PM</strong>
      </div>

      <div class="working-time">
        <span>Friday</span>
        <strong>07:00 AM – 09:00 PM</strong>
      </div>

      <div class="working-time">
        <span>Saturday</span>
        <strong>07:00 AM – 09:00 PM</strong>
      </div>

      <div class="working-time">
        <span>Sunday</span>
        <strong>Closed</strong>
      </div>
    </div>
  </div>
</section>



<section className="service-info-section">
  <div className="service-info-container">

    <div className="service-info-header">
      <span>SERVICE DETAILS</span>
      <h2>Service Information</h2>

      <p>
        Clear information about our service charges and repair process.
      </p>
    </div>

    <div className="service-charge-box">

      <div className="service-check-icon">
        ✓
      </div>

      <div className="service-charge-content">

        <h3>Service Charge</h3>

        <div className="service-price">
          ₹400+
        </div>

        <p>
          The applicable basic service charge starts from ₹400.
          If any spare parts need replacement, our technician will
          explain the issue and inform you of the applicable cost
          before proceeding.
        </p>

        <div className="service-approval-note">
          <span>✓</span>

          <p>
            Spare part replacement or additional repair work will be
            carried out only after receiving your approval.
          </p>
        </div>

      </div>

    </div>

  </div>
</section>

    </>
  );
}

export default ACService;